import Left from "@repo/icons/default/Left";
import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router";
import { useState } from "react";
import type { ReactElement } from "react";
import { CpsButton, CpsCheckboxGroup, CpsCheckboxV2 } from "corpus";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import {
  type PatientPaymentsPageSearchSchema,
  patientPaymentsPageSearchSchema,
} from "@/lib/form-schemas/patient-payments-page-search-schema";

const FilterOrigins = (): ReactElement => {
  const navigate = useNavigate();
  const router = useRouter();

  const navigateBack = (): void => {
    void router.navigate({
      to: "/settings/payments/patient-payments",
      search: { ...searchParams, back: (searchParams.back ?? 0) + 2, action: undefined },
    });
  };

  const searchParams = useSearch({
    from: "/settings/payments/patient-payments/filters/filter-origins",
  });

  const [originsSelected, setOriginsSelected] = useState<string[]>(
    searchParams.origins ?? [],
  );

  const handleOriginsChange = (values: string[]): void => {
    setOriginsSelected(values);
  };

  const handleSubmit = (): void => {
    const newSearch: PatientPaymentsPageSearchSchema = {
      ...searchParams,
      back: (searchParams.back ?? 0) + 1,
      origins: originsSelected,
    };
    void navigate({
      to: "/settings/payments/patient-payments",
      search: newSearch,
      replace: true,
    });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={navigateBack} align="start" icon={Left} />
        <HeaderTitle title="Filtro de origens de pagamento" align="center" />
      </HeaderRoot>
      <Page className="flex flex-col justify-between">
        <CpsCheckboxGroup name="origins-checkbox-group" onChange={handleOriginsChange}>
          <CpsCheckboxV2
            value="online"
            label="Link de pagamento"
            checked={originsSelected.includes("online")}
          />
          <CpsCheckboxV2
            value="totem"
            label="Totem"
            checked={originsSelected.includes("totem")}
          />
        </CpsCheckboxGroup>
        <CpsButton color="secondary" fullWidth onClick={handleSubmit}>
          Aplicar filtros
        </CpsButton>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/filters/filter-origins",
)({
  component: FilterOrigins,
  validateSearch: patientPaymentsPageSearchSchema,
});
